import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'

import { Modal } from '@peracto/peracto-ui'
import { HTMLRenderer } from '@react-page/renderer'

import draggable from '../../ContentBlockList/Draggable'
import * as S from '../styled'

const uniquifyCell = cell => {
    delete cell.id

    if (!cell?.rows || cell.rows.length === 0) {
        return cell
    }

    const cellClone = {
        ...cell,
        rows: cell?.rows?.map(row => {
            const uniqueRow = {
                ...row,
            }

            delete uniqueRow.id

            if (row?.cells?.length > 0) {
                uniqueRow.cells = row?.cells?.map(cell => {
                    return uniquifyCell(cell)
                })
            }
            return uniqueRow
        }),
    }

    return cellClone
}

const LibraryBlock = ({ block, editor, plugins, handleDelete }) => {
    const [showModal, setShowModal] = useState(false)

    const { name, body } = block

    const state = JSON.parse(body)[0]

    const { cells } = state

    const Draggable = draggable(cells?.[0]?.layout?.plugin?.name)

    return (
        <S.LibraryBlock>
            <div className="content-editor__block" style={{ margin: '15px 0' }}>
                <div className="content-editor__block--icon">
                    <Draggable insert={editor.plugins.unserialize(uniquifyCell(cells[0]))}>
                        <HTMLRenderer state={state} plugins={plugins} />
                    </Draggable>
                </div>
                <S.ItemName>
                    <span>{name}</span>
                    <button className="btn btn-light" onClick={() => setShowModal(true)}>
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </S.ItemName>
            </div>

            {showModal && (
                <Modal
                    isVisible={showModal}
                    title="Delete Library Block"
                    close={() => setShowModal(false)}
                    buttons={[
                        {
                            type: 'btn-outline-secondary',
                            text: 'Close',
                            action: () => setShowModal(false),
                        },
                        {
                            type: 'btn-danger',
                            text: 'Delete Block',
                            action: handleDelete(block),
                        },
                    ]}
                >
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        size="4x"
                        className="!block !mb-6"
                    />
                    Are you sure you would like to permanently delete "{block.name}"?
                </Modal>
            )}
        </S.LibraryBlock>
    )
}

export default LibraryBlock
